/* eslint-disable @typescript-eslint/camelcase */
import { getHubData } from "@/app/infrastructures/misc/Cookies";
import { QueryParamsEntities4 } from "./MainApp";
import { Pagination } from "./Pagination";

export class HangingLastMileSummary {
  lastSync = "";
  activitiesPending = 0;
  activitiesDone = 0;
  totalActivities = 0;
  courierHangingPending = 0;
  courierHangingDone = 0;
  totalCourierHanging = 0;
  delHangingPending = 0;
  delHangingDone = 0;
  totalDelHanging = 0;
  dexHangingPending = 0;
  dexHangingDone = 0;
  totalDexHanging = 0;
  codrejHangingPending = 0;
  codrejHangingDone = 0;
  totalCodrejHanging = 0;

  constructor(fields?: Partial<HangingLastMileSummary>) {
    Object.assign(this, fields);
  }
}

export class GroupSummaryLastMile {
  totalManifest = 0;
  totalStt = 0;

  constructor(fields?: Partial<GroupSummaryLastMile>) {
    Object.assign(this, fields);
  }
}
export class HistoryFollowUpLastMileEntities {
  pagination: Pagination;
  data: HistoryFollowUpLastMile[];
  constructor(pagination: Pagination, data: HistoryFollowUpLastMile[]) {
    this.pagination = pagination;
    this.data = data;
  }
}
export class HistoryFollowUpLastMile {
  date = "";
  activities: ActivitiesDetail[] = [];

  constructor(fields?: Partial<HistoryFollowUpLastMile>) {
    Object.assign(this, fields);
  }
}

export class GroupSttsLastMile {
  no = 0;
  noManifest = "";
  sttNo = "";
  isAggregator = false;
  hangingDays = 0;
  existenceStatus = "";
  existenceLocation = "";
  existenceLocationnote = "";
  existenceUsername = "";
  existenceFindAt = "";
  isChecked = false;

  constructor(fields?: Partial<GroupSttsLastMile>) {
    Object.assign(this, fields);
  }
}

export class FollowUpGroupLastMile {
  groupName = "";
  summary: GroupSummaryLastMile = new GroupSummaryLastMile();
  stts: GroupSttsLastMile[] = [];
  isChecked = false;

  constructor(fields?: Partial<FollowUpGroupLastMile>) {
    Object.assign(this, fields);
  }
}

export class FollowUpLastMile {
  courierName = "";
  courierPhone = "";

  constructor(fields?: Partial<FollowUpLastMile>) {
    Object.assign(this, fields);
  }
}
export class FollowUpDetail {
  courierName = "";
  courierPhone = "";
  username = "";
  origin3lc = "";
  originName = "";

  constructor(fields?: Partial<FollowUpDetail>) {
    Object.assign(this, fields);
  }
}

export class HangingLastMile {
  activityId = 0;
  activityType = "";
  followUpStatus = "";
  followUp: FollowUpLastMile = new FollowUpLastMile();
  groups: FollowUpGroupLastMile[] = [];
  isCollapsed = false;
  followUpById = 0;
  followUpByUsername = "";
  followUpAt = "";

  constructor(fields?: Partial<HangingLastMile>) {
    Object.assign(this, fields);
  }
}

export class ActivitiesDetail {
  activityId = 0;
  activityType = "";
  statusFollowUp = "";
  followUp: FollowUpDetail = new FollowUpDetail();
  username = "";
  createdAt = "";

  constructor(fields?: Partial<ActivitiesDetail>) {
    Object.assign(this, fields);
  }
}

export class HistoryFollowUpLastMileRequest {
  activityType = "";
  date = "";
  page = 1;
  limit = 10;
  startDate = "";
  endDate = "";

  constructor(fields?: Partial<HistoryFollowUpLastMileRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities4({
      ...this,
      hub_id: getHubData()?.hubId || 0
    }).queryString;
  }
}
